import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  padding: 30px 60px;

  ${media.xs`
    padding: 30px;
  `}
  
  ${media.lg`
    padding: 30px 30px 40px;
  `}
`

const Text = styled.blockquote`
  font-size: 26px;
  line-height: 34px;
  font-weight: 300;
  margin: 0;
  padding: 20px 0 0;
  color: ${props => props.theme.colors.grey.dark};
  
  &:before {
    content: '“ ';
    color: ${props => props.theme.colors.theme.base};
  }
  
  ${media.xs`
    padding: 0;
    font-size: 22px;
    line-height: 26px;
  `}

  ${media.xl`
    font-size: 32px;
    line-height: 40px;
  `}
`

const Info = styled.div`
  display: flex;
  width: 100%;
  margin-top: 35px;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  align-items: center;
  color: ${props => props.theme.colors.grey.dark};

  p {
    margin: 0;
  }
`

const ProfilePicture = styled.div`
  width: 75px;
  height: 75px;
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.image});
  border-radius: 75px;
  margin-right: 28px;
  flex-shrink: 0;
`

const InfoByline = styled.p`
  color: ${props => props.theme.colors.theme.base};
`

export default class Quote extends Component {
  
  render() {
    const {
      quote,
      title,
      byline,
      image
    } = this.props

    return(
      <Wrapper>
        <Text>{quote}</Text>
        <Info>
          <ProfilePicture image={image.sourceUrl} />
          <div>
            <p>{title}</p>
            <InfoByline>{byline}</InfoByline>
          </div>
        </Info>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Quotes/Quote.js